import React from "react";
import { Input } from "../ui/input";
import { getCountryConfig } from "../../utils/countryConfig";
import { digitsOnlyPhone } from "../../utils/phoneValidation";

/**
 * Phone input with read-only country calling code. User enters national number only.
 */
const PhoneNumberField = ({
  country = "US",
  phoneCountryCode,
  value = "",
  onChange,
  name = "phoneNumber",
  id,
  disabled = false,
  placeholder = "Phone Number",
  className = "",
  inputClassName = "",
  testId,
  tabIndex,
}) => {
  const config = getCountryConfig(country);
  const displayCode = phoneCountryCode || config.phoneCountryCode;
  const maxLen = config.nationalMaxLength;

  const handleChange = (e) => {
    const digits = digitsOnlyPhone(e.target.value, maxLen);
    onChange?.({
      target: { name, value: digits },
    });
  };

  return (
    <div className={`relative flex items-stretch ${className}`}>
      <span
        className="inline-flex h-10 items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-600 dark:border-[#464c59] dark:bg-[#2c3440] dark:text-gray-300"
        aria-label={`Country code ${displayCode}`}
      >
        {displayCode}
      </span>
      <Input
        fullWidth={true}
        disableUnderline={true}
        id={id || name}
        name={name}
        type="tel"
        inputMode="numeric"
        maxLength={maxLen}
        placeholder={placeholder}
        value={value || ""}
        onChange={handleChange}
        disabled={disabled}
        className={`rounded-l-none ${inputClassName}`}
        tabIndex={tabIndex}
        data-testid={testId}
      />
    </div>
  );
};

export default PhoneNumberField;
